import type { QueryHookOptions } from "@apollo/client";
import { useQuery, gql } from "@apollo/client";

import type { OauthScopeDescriptionFragment } from "@unauthenticated/oauth/data/fragments";
import { OAUTH_SCOPE_DESCRIPTION_FRAGMENT } from "@unauthenticated/oauth/data/fragments";

const GET_OAUTH_AUTHORIZATIONS = gql`
  query oauthAuthorizations_UnauthenticatedOAuth_Query($clientId: [ID!]!) {
    viewer {
      oauthApplication(clientId: $clientId) {
        clientId
        name
        redirectUri
        scopes
        scopeDescriptions {
          ...OauthScopeDescriptionFragment
        }
      }
    }
  }
  ${OAUTH_SCOPE_DESCRIPTION_FRAGMENT}
`;

interface OauthAuthorizationsData {
  viewer: {
    oauthApplication: {
      clientId: string;
      name: string;
      redirectUri: string;
      scopes: string;
      scopeDescriptions: OauthScopeDescriptionFragment[];
    };
  };
}

interface Variables {
  clientId: string;
}

const useOauthAuthorizationsQuery = (
  options?: QueryHookOptions<OauthAuthorizationsData, Variables>
) => {
  return useQuery<OauthAuthorizationsData, Variables>(GET_OAUTH_AUTHORIZATIONS, options);
};

export type { OauthAuthorizationsData };
export { useOauthAuthorizationsQuery, GET_OAUTH_AUTHORIZATIONS };
